//import React, { useState, useEffect,useContext } from 'react';
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
//import { AppContext } from './MyContextProvider'; // Import your context provider

export default function Root() {

  return (
		<div>
		  <Header />
		  <div className="content">
			<Outlet />
		  </div>
		</div>
  );
}
